module.exports = __webpack_public_path__ + "static/media/notice.5c38388a.png";